import React, { MouseEventHandler, useMemo } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { extractStatusText, getActiveUntil } from 'flow/utils';
import { useAppSelector } from 'flow/hooks/useRedux';
import { ChannelKey } from 'flow/types/EntityKeys';
import {
    makeSelectOwnUserIsLoggedInToChannel,
    selectChannelActiveProfile,
    selectChannelActiveProfileIsAvailable,
    selectChannelName,
    selectChannelUnreadMessagesCount,
} from 'flow/selectors/channel-selectors';
import AgentsLoggedInToChannelCount from './AgentsLoggedInToChannelCount';
import PbxListItem from './PbxListItem';
import { RowMarking } from './BaseListItem';

interface Props {
    itemKey: ChannelKey;
    onClick: MouseEventHandler;
    marking?: RowMarking;
}

const ListItemPbxLiveChat = ({ itemKey, onClick, marking }: Props) => {
    const { i18next } = useAppContext();

    const selectOwnUserIsLoggedInToChannel = useMemo(
        makeSelectOwnUserIsLoggedInToChannel,
        [],
    );
    const ownUserIsLoggedInToChannel = useAppSelector((state) =>
        selectOwnUserIsLoggedInToChannel(state, itemKey),
    );
    const activeProfile = useAppSelector((state) =>
        selectChannelActiveProfile(state, itemKey),
    );
    const activeProfileIsAvailable = useAppSelector((state) =>
        selectChannelActiveProfileIsAvailable(state, itemKey),
    );
    const channelName = useAppSelector((state) =>
        selectChannelName(state, itemKey),
    );
    const selectUnreadMessagesCount = useAppSelector((state) =>
        selectChannelUnreadMessagesCount(state, itemKey),
    );

    return (
        <PbxListItem
            onClick={onClick}
            marking={marking}
            type="liveChat"
            title={channelName}
            description={
                activeProfile &&
                `${extractStatusText(
                    activeProfile,
                    i18next,
                )} ${getActiveUntil(activeProfile, i18next)}`
            }
            notificationCount={
                ownUserIsLoggedInToChannel ? selectUnreadMessagesCount : null
            }
        >
            {activeProfileIsAvailable ? (
                <AgentsLoggedInToChannelCount
                    channelKey={itemKey}
                    isSelected={marking !== undefined}
                />
            ) : null}
        </PbxListItem>
    );
};

export default ListItemPbxLiveChat;
